export default "__VITE_ASSET__B9LU61k___"